import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class TransmittedRemoteActionDbTableDefinition extends DbTableDefinition {
  tableName = 'sent_remote_actions';
  tableStructure = `(id INTEGER PRIMARY KEY,
       endpoint VARCHAR(100) NOT NULL,
       data TEXT,
       cachable BOOLEAN,
       fifo BOOLEAN,
       authenticationRequired BOOLEAN,
       rawRequestTimestamp LONG,
       editedRequestTimestamp LONG,
       executionTimestamp LONG,
       shortLabel TEXT,
       shortLabelTranslate BOOLEAN,
       longLabel TEXT, 
       longLabelTranslate BOOLEAN
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'hideInDayProtocol',
        type: 'BOOLEAN',
      });
    } else {
      this.updateStatements.set(13, [
        `ALTER TABLE ${this.tableName} ADD COLUMN hideInDayProtocol BOOLEAN;`,
      ]);
    }
  }
}
